// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"CustomersList_contentComponent__2uPaf","tableContainer":"CustomersList_tableContainer__iIAJw","rangePicker":"CustomersList_rangePicker__2eCbL"};